/* eslint-disable */
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DownloadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Modal, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import UilPlus from '@iconscout/react-unicons/icons/uil-plus';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { columns, dataSource } from './utils';
import { AddEditLogistics } from './addEdit';
import { GlobalUtilityStyle, PaginationStyle } from '../styled';
import { PageHeader } from '../../components/page-headers/page-headers';
import { DataDelete, DataRead, DataSearch } from '../../redux/logistics/actionCreator';

const { confirm } = Modal;

function Logistics() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.logistics);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, updateEdit] = useState(null);
  const roleId = useSelector((store) => store.auth.loginData?.role_id ?? 0);

  const [pagination, setPagination] = useState({ size: 100, page: 1 });

  const showModal = () => {
    updateEdit(null);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    dispatch(DataRead());
    setIsModalOpen(false);
    updateEdit(null);
  };

  const handleCancel = () => {
    updateEdit(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (dispatch) {
      dispatch(DataRead());
    }
  }, [dispatch]);

  const [state, setState] = useState({
    selectedRowKeys: [],
  });
  const { selectedRowKeys } = state;

  const handleDelete = (id) => {
    confirm({
      title: 'Are you sure delete this logistic?',
      icon: <ExclamationCircleFilled />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        dispatch(
          DataDelete({
            id,
            getData: () => {
              dispatch(DataRead());
            },
          }),
        );
      },
      onCancel() {
        return false;
      },
    });
    return false;
  };

  const handleEdit = (editData) => {
    updateEdit(editData);
    setIsModalOpen(true);
  };

  const onHandleSearch = (e) => {
    dispatch(DataSearch(e.target.value));
  };

  const onSelectChange = (selectedRowKey) => {
    setState({ ...state, selectedRowKeys: selectedRowKey });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleExport = () => document.getElementById('table-xls-button').click();

  React.useEffect(() => {
    let table = document.getElementsByTagName('table')?.[0];
    if (table) {
      table.id = 'logistics-table';
    }
  }, [loading]);

  return (
    <div>
      <PageHeader
        className="flex items-center justify-between px-[30px] py-[25px] bg-transparent [&>div>div>.ant-page-header-heading-title]:text-[22px] [&>div>div>.ant-page-header-heading-title]:font-semibold [&>div>div>.ant-page-header-heading-title]:text-dark dark:[&>div>div>.ant-page-header-heading-title]:text-white leading-[32px] [&>div>div]:flex [&>div>div]:items-center gap-[12px] [&>div]:flex [&>div]:flex-wrap [&>div]:items-center [&>div]:w-full [&>div]:gap-[10px] [&>div>.ant-page-header-heading-left]:m-0 [&>div>.ant-page-header-heading-left]:gap-[12px]"
        subTitle={
          <>
            {roleId === 5 && (
              <Link
                className="bg-primary hover:bg-hbr-primary border-solid border-1 border-primary text-white dark:text-white87 text-[14px] font-semibold leading-[22px] inline-flex items-center justify-center rounded-[4px] px-[20px] h-[44px] shadow-btn gap-[8px]"
                to="#"
                onClick={showModal}
              >
                <UilPlus className="w-[15px] h-[15px]" /> <span>Add New Logistics</span>
              </Link>
            )}
          </>
        }
        buttons={[
          <div key={1} className="relative">
            <span className="absolute left-[18px] top-[50%] translate-y-[-50%]">
              <UilSearch className="w-[16px] h-[16px] text-light dark:text-white60" />
            </span>
            <input
              className="border-none h-[40px] min-w-[280px] ltr:pl-[45px] ltr:pr-[20px] rtl:pr-[45px] rtl:pl-[20px] rounded-6 bg-white dark:bg-white10 focus-none outline-none"
              onChange={onHandleSearch}
              type="text"
              name="recored-search"
              placeholder="Search Here"
            />
          </div>,
        ]}
        ghost
        title={`Logistics (${data?.length ?? 0})`}
      />

      <ReactHTMLTableToExcel
        id="table-xls-button"
        className=" hidden"
        table="logistics-table"
        filename="ThawemarinLogistics"
        sheet="Sheet1"
        buttonText="Download as XLS" />

      <div className="min-h-[715px] lg:min-h-[580px] flex-1 h-auto px-8 xl:px-[15px] pb-[30px] bg-transparent">
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <div className="bg-white dark:bg-white10 p-[25px] rounded-[10px]">
              {loading ? (
                <div className="flex items-center justify-center [&>div]:flex [&>div]:items-center">
                  <Spin />
                </div>
              ) : (
                <GlobalUtilityStyle>
                  <PaginationStyle>
                    <div className="ant-pagination-custom-style relative table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-white10 min-sm:p-[25px] rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                      <Table
                        className="[&>div>div>.ant-table]:mb-7 [&>div>div>.ant-table]:pb-5 [&>div>div>.ant-table]:border-b [&>div>div>.ant-table]:border-regular dark:[&>div>div>.ant-table]:border-white10 ltr:[&>div>div>div>div>div>table>thead>tr>th:first-child]:pl-[20px] ltr:[&>div>div>div>div>div>table>tbody>tr>td:first-child]:pl-[20px] rtl:[&>div>div>div>div>div>table>thead>tr>th:first-child]:pr-[20px] rtl:[&>div>div>div>div>div>table>tbody>tr>td:first-child]:pr-[20px]"
                        // rowSelection={rowSelection}
                        pagination={{
                          current: pagination.page,
                          pageSize: pagination.size,
                          showSizeChanger: true,
                          onChange: (page, pageSize) => {
                            setPagination({ ...pagination, size: pageSize, page: page })
                          },
                          pageSizeOptions: [10, 20, 50, 100, 500, 1000, 2000, 5000]
                        }}
                        dataSource={dataSource(handleDelete, handleEdit, data)}
                        columns={roleId === 5 ? columns : [columns[0], columns[1], columns[2]]}
                      />
                      <Button className='absolute left-0 bottom-8' onClick={handleExport} type="primary" shape="round" icon={<DownloadOutlined />} size={"large"}>
                        Download
                      </Button>
                    </div>
                  </PaginationStyle>
                </GlobalUtilityStyle>
              )}
            </div>
          </Col>
        </Row>
      </div>
      {isModalOpen && (
        <Modal
          footer={[]}
          title={isEdit ? 'Edit Logistics' : 'Add Logistics'}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <AddEditLogistics data={isEdit} handleClose={handleOk} />
        </Modal>
      )}
    </div>
  );
}

export default Logistics;
